import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import logo from "../assets/img/logo.png";
import croppedLogo from "../assets/img/logo-cropped.png";
import { FiUser } from 'react-icons/fi';
import { MdKeyboardArrowDown, MdLogin, MdLogout } from 'react-icons/md';
import { BiWindowOpen } from 'react-icons/bi';
import { userLogoutAction } from "../redux/actions/userActions";

const Header = () => {
  const dispatch = useDispatch()

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const [customOffset, setCustomOffset] = useState(0)
  const [toggleNav, setNavToggle] = useState(false)
  const [dropdown, setDropdown] = useState(false)
  
  useEffect(() => {
    window.onscroll = () => {
      const offset = window.pageYOffset
      setCustomOffset(offset)
    }
  }, [customOffset])

  const handleLogoutUser = () => {
		dispatch(userLogoutAction())
	}

  return (
    <header id="header" className={customOffset ? "scroll-up" : ""}>
      <nav className="container">
        <NavLink to="/" className="nav-link">
          <span>Home</span>
        </NavLink>
        <NavLink to="/about" className="nav-link">
          <span>About Us</span>
        </NavLink>
        <NavLink to="/property" className="nav-link">
          <span>Property</span>
        </NavLink>
        <NavLink to="/" className="company-logo">
          <img src={customOffset ? croppedLogo : logo} alt="Island Luxury" />
        </NavLink>
        {/* <NavLink to="/agents" className="nav-link">
          <span>Agent</span>
        </NavLink> */}
        <NavLink to="/request" className="nav-link">
          <span>Request</span>
        </NavLink>
        <NavLink to="/contact" className="nav-link">
          <span>Contact</span>
        </NavLink>
        <button className="header-btn acct" onClick={() => setDropdown(!dropdown)}>
          <FiUser size={25} />
          <span>Account</span>
          <MdKeyboardArrowDown size={20} />
        </button>
        
        <div className={dropdown ? "dropdown display" : "dropdown"}>
          <div className="dropdown_cont">
            {userInfo ?
              <>
                <NavLink to="/dashboard" className="acct-item signed-user">
                  <FiUser size={23} />
                  <div>
                    <p>Signed in as</p>
                    <strong>{userInfo.firstname}</strong>
                  </div>
                </NavLink>
                <button className="acct-item" onClick={handleLogoutUser}>
                  <MdLogout size={23} />
                  <span>Sign Out</span>
                </button>
              </> 
            : 
              <>
                <NavLink to="/signup" className="acct-item">
                  <BiWindowOpen size={23} />
                  <span>Sign Up</span>
                </NavLink>
                <NavLink to="/login" className="acct-item">
                  <MdLogin size={23} />
                  <span>Sign In</span>
                </NavLink>
              </>
            }
          </div>
        </div>

        <div className={toggleNav ? "menu-btn close" : "menu-btn"} onClick={() => setNavToggle(!toggleNav)}>
          <div className="btn-line" />
          <div className="btn-line" />
          <div className="btn-line" />
        </div>
      </nav>
      <div className={toggleNav ? "mobile-menu display" : "mobile-menu"}>
        <div className="nav-wrap">
          <NavLink to="/about" className="nav-link">
            <span>About Us</span>
          </NavLink>
          <NavLink to="/property" className="nav-link">
            <span>Property</span>
          </NavLink>
          <NavLink to="/request" className="nav-link">
            <span>Request</span>
          </NavLink>
          {/* <NavLink to="/agents" className="nav-link">
            <span>Agent</span>
          </NavLink> */}
          <NavLink to="/contact" className="nav-link">
            <span>Contact</span>
          </NavLink>
          <NavLink to="/login" className="nav-link">
            <span>Sign In</span>
          </NavLink>
          <div className="dropdown_cont">
            {userInfo ?
              <>
                <NavLink to="/dashboard" className="acct-item signed-user">
                  <FiUser size={23} />
                  <div>
                    <p>Signed in as</p>
                    <strong>{userInfo.firstname}</strong>
                  </div>
                </NavLink>
                <button className="acct-item" onClick={handleLogoutUser}>
                  <MdLogout size={23} />
                  <span>Sign Out</span>
                </button>
              </> 
            : 
              <>
                <NavLink to="/signup" className="acct-item">
                  <BiWindowOpen size={23} />
                  <span>Sign Up</span>
                </NavLink>
                <NavLink to="/login" className="acct-item">
                  <MdLogin size={23} />
                  <span>Sign In</span>
                </NavLink>
              </>
            }
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header;